(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[352],{

/***/ 3552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _Loaders_FullScreenLoader_Loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5815);
/* harmony import */ var _Auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4392);
/* harmony import */ var _context_AuthContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(175);
/* harmony import */ var _utils_object__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8760);
/* harmony import */ var _PrivateRoute_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7361);
/* harmony import */ var _PrivateRoute_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_PrivateRoute_module_scss__WEBPACK_IMPORTED_MODULE_6__);







const PrivateRoute = (props)=>{
    const { authLoading , user  } = (0,_context_AuthContext__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .aC)();
    if (authLoading) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Loaders_FullScreenLoader_Loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        isLoading: authLoading
    });
    if ((0,_utils_object__WEBPACK_IMPORTED_MODULE_5__/* .isEmptyObject */ .Qr)(user)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_PrivateRoute_module_scss__WEBPACK_IMPORTED_MODULE_6___default().authWrapper),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Auth__WEBPACK_IMPORTED_MODULE_3__/* .Auth */ .g, {})
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: props.children
        });
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (PrivateRoute);


/***/ }),

/***/ 5559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3935);
/* harmony import */ var _icons_close__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2645);
/* harmony import */ var _hooks_useWindowDimensions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7463);
/* harmony import */ var _Modal_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2145);
/* harmony import */ var _Modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Modal_module_scss__WEBPACK_IMPORTED_MODULE_5__);






const Modal = (props)=>{
    const { isMobile  } = (0,_hooks_useWindowDimensions__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    const initialStyles = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        const defaultSize = isMobile ? 90 : 80;
        return {
            width: props.width || "".concat(defaultSize, "vw"),
            height: props.height || "".concat(defaultSize, "vh"),
            ...props.styles
        };
    }, [
        props
    ]);
    const [container, setContainer] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (typeof document !== "undefined") {
            const modalRoot = document.getElementById("portal-modal");
            if (!container) {
                const newContainer = document.createElement("div");
                setContainer(newContainer);
                modalRoot === null || modalRoot === void 0 ? void 0 : modalRoot.appendChild(newContainer);
            }
            return ()=>{
                if (container) {
                    modalRoot === null || modalRoot === void 0 ? void 0 : modalRoot.removeChild(container);
                }
            };
        }
    }, [
        container
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const handleEscape = (e)=>{
            if (props.toggleModal && e.key === "Escape") {
                props.toggleModal();
            }
        };
        if (props.isOpen) {
            window.addEventListener("keydown", handleEscape);
        }
        return ()=>{
            window.removeEventListener("keydown", handleEscape);
        };
    }, [
        props
    ]);
    const renderModalContent = ()=>{
        return props.isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dialog", {
            className: (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalContainer),
            onClick: props.toggleModal,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                style: initialStyles,
                onClick: (e)=>e.stopPropagation(),
                className: (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalBody),
                children: [
                    props.showHeader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalHeader),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().headerContent),
                                children: props.headerContent ? props.headerContent : null
                            }),
                            !props.hideCloseButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().closeIcon),
                                onClick: props.toggleModal,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons_close__WEBPACK_IMPORTED_MODULE_3__/* .CloseIcon */ .T, {
                                    color: "#e1c7fb"
                                })
                            })
                        ]
                    }),
                    props.children
                ]
            })
        }) : null;
    };
    return container ? /*#__PURE__*/ react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal(renderModalContent(), container) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (Modal);


/***/ }),

/***/ 4252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Navbar_Navbar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./components/Typography/Brand/Brand.tsx
var Brand = __webpack_require__(2737);
// EXTERNAL MODULE: ./components/Modal/Modal.tsx
var Modal = __webpack_require__(5559);
// EXTERNAL MODULE: ./services/files.ts
var files = __webpack_require__(2420);
// EXTERNAL MODULE: ./utils/arrays.ts
var arrays = __webpack_require__(91);
// EXTERNAL MODULE: ./context/AuthContext.tsx
var AuthContext = __webpack_require__(175);
// EXTERNAL MODULE: ./services/users.ts
var users = __webpack_require__(7077);
// EXTERNAL MODULE: ./context/ToastContext.tsx
var ToastContext = __webpack_require__(5887);
// EXTERNAL MODULE: ./components/Inputs/InputText/InputText.tsx
var InputText = __webpack_require__(2469);
// EXTERNAL MODULE: ./components/EditProfileForm/EditProfileForm.module.scss
var EditProfileForm_module = __webpack_require__(9825);
var EditProfileForm_module_default = /*#__PURE__*/__webpack_require__.n(EditProfileForm_module);
// EXTERNAL MODULE: ./components/buttons/ButtonPushable/ButtonPushable.tsx
var ButtonPushable = __webpack_require__(7272);
;// CONCATENATED MODULE: ./components/EditProfileForm/EditProfileForm.tsx










const EditProfileForm = ()=>{
    const { user , loadUser  } = (0,AuthContext/* useAuth */.aC)();
    const { showSuccessAlert , showErrorAlert  } = (0,ToastContext/* useToastContext */.a)();
    const [newAvatar, setNewAvatar] = (0,react.useState)(null);
    const [name, setName] = (0,react.useState)(InputText/* initialText */.WG);
    const [email, setEmail] = (0,react.useState)(InputText/* initialText */.WG);
    const [bio, setBio] = (0,react.useState)(InputText/* initialText */.WG);
    const [loading, setLoading] = (0,react.useState)(false);
    const [formValid, setFormValid] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (user) {
            setName({
                ...name,
                value: user.name
            });
            setBio({
                ...bio,
                value: user.bio || ""
            });
        }
    }, [
        user
    ]);
    (0,react.useEffect)(()=>{
        setFormValid(name.value && (0,arrays/* isAllTrue */.IE)(name.validators) && (0,arrays/* isAllTrue */.IE)(bio.validators) || false);
    }, [
        name,
        bio
    ]);
    const handleFormSubmit = async (event)=>{
        event.preventDefault();
        const newUser = {
            ...user,
            name: name.value,
            bio: bio.value
        };
        setLoading(true);
        try {
            if (newAvatar) {
                const response = await (0,files/* uploadFileToServer */.w)(newAvatar, "avatars");
                if (response.success) {
                    newUser.avatar = response.data;
                } else {
                    showErrorAlert("Error uploading the avatar");
                }
            }
            const response1 = await (0,users/* updateUserInfo */.gS)(newUser);
            if (response1.success) {
                showSuccessAlert("User data updated successfully");
                await loadUser(user.email);
                setLoading(false);
            }
        } catch (error) {
            showErrorAlert(error.message || "Error updating user");
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        className: (EditProfileForm_module_default()).editProfileForm,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputText/* default */.ZP, {
                variant: "transparent",
                id: "inputTextEditUserName",
                label: "Full name",
                placeholder: "Username",
                text: name,
                setText: setName,
                isRequired: true,
                minValueLength: 2,
                maxValueLength: 50
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (EditProfileForm_module_default()).button,
                onClick: handleFormSubmit,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonPushable/* default */.Z, {
                    children: "Save changes"
                })
            })
        ]
    });
};
/* harmony default export */ var EditProfileForm_EditProfileForm = (EditProfileForm);

// EXTERNAL MODULE: ./components/icons/close.tsx
var icons_close = __webpack_require__(2645);
// EXTERNAL MODULE: ./hooks/useWindowDimensions.ts + 1 modules
var useWindowDimensions = __webpack_require__(7463);
// EXTERNAL MODULE: ./components/UserProfile/UserProfile.module.scss
var UserProfile_module = __webpack_require__(8790);
var UserProfile_module_default = /*#__PURE__*/__webpack_require__.n(UserProfile_module);
;// CONCATENATED MODULE: ./components/UserProfile/UserProfile.tsx








const UserProfile = ()=>{
    const { user  } = (0,AuthContext/* useAuth */.aC)();
    const { showSuccessAlert , showWarningAlert , showErrorAlert  } = (0,ToastContext/* useToastContext */.a)();
    const { isMobile  } = (0,useWindowDimensions/* default */.Z)();
    const confirmRemove = ()=>{
        showWarningAlert("Are you sure you want to delete your account?", "Confirm", handleRemove);
    };
    const handleRemove = ()=>{
        (0,users/* removeUserInfo */.TT)(user.email).then((response)=>{
            if (response) {
                showSuccessAlert("User removed");
                (0,users/* logout */.kS)().then(()=>{
                    window.location.href = "/";
                });
            }
        }).catch((error)=>{
            showErrorAlert(error.message || "Error removing user");
        });
    };
    const DeleteAccount = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (UserProfile_module_default()).navItem,
        onClick: confirmRemove,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_close/* CloseIcon */.T, {
                width: "16",
                height: "16",
                color: "#B3005E"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "base-2 main",
                children: "Delete account"
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (UserProfile_module_default()).userProfileContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EditProfileForm_EditProfileForm, {}),
            DeleteAccount
        ]
    });
};
/* harmony default export */ var UserProfile_UserProfile = (UserProfile);

// EXTERNAL MODULE: ./components/icons/logout.tsx
var icons_logout = __webpack_require__(4400);
// EXTERNAL MODULE: ./components/icons/user.tsx
var icons_user = __webpack_require__(7235);
// EXTERNAL MODULE: ./context/ImagineContext.tsx + 5 modules
var ImagineContext = __webpack_require__(7524);
// EXTERNAL MODULE: ./utils/object.ts
var object = __webpack_require__(8760);
// EXTERNAL MODULE: ./components/UserCard/UserCard.module.scss
var UserCard_module = __webpack_require__(1529);
var UserCard_module_default = /*#__PURE__*/__webpack_require__.n(UserCard_module);
;// CONCATENATED MODULE: ./components/UserCard/UserCard.tsx










const UserImage = (props)=>{
    const { user  } = (0,AuthContext/* useAuth */.aC)();
    const getImageStyles = ()=>{
        return {
            width: props.size,
            minWidth: props.size,
            maxWidth: props.size,
            height: props.size,
            minHeight: props.size,
            maxHeight: props.size
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (UserCard_module_default()).userImage,
        style: getImageStyles(),
        children: user.avatar ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: user.avatar,
            alt: "avatar",
            style: getImageStyles(),
            loading: "lazy"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_user/* UserIcon */.t, {
            width: "24px",
            height: "24px"
        })
    });
};
const UserCard = (props)=>{
    const { user , logout  } = (0,AuthContext/* useAuth */.aC)();
    const { clearResults  } = (0,ImagineContext/* useImagine */.Y)();
    const [showEditModal, setShowEditModal] = (0,react.useState)(false);
    const handleLogout = ()=>{
        clearResults();
        logout().then(()=>{
            window.location.href = "/";
        });
    };
    if ((0,object/* isEmptyObject */.Qr)(user)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            props.showCard && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: ()=>props.setShowCard(false),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (UserCard_module_default()).userCardContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (UserCard_module_default()).actionsContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (UserCard_module_default()).profileItem,
                                onClick: ()=>setShowEditModal(true),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (UserCard_module_default()).icon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_user/* UserIcon */.t, {
                                            width: "16",
                                            height: "16",
                                            color: "white"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "base-1",
                                        children: "Edit Profile"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (UserCard_module_default()).logoutItem,
                                onClick: handleLogout,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (UserCard_module_default()).icon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_logout/* LogoutIcon */.R, {
                                            width: "16",
                                            height: "16",
                                            color: "#B3005E"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "base-1",
                                        children: "Log out"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                showHeader: true,
                headerContent: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "headline-4",
                    children: "Edit Profile"
                }),
                width: "auto",
                height: "auto",
                isOpen: showEditModal,
                toggleModal: ()=>setShowEditModal(!showEditModal),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserProfile_UserProfile, {})
            })
        ]
    });
};
/* harmony default export */ var UserCard_UserCard = (UserCard);

// EXTERNAL MODULE: ./context/SDContext.tsx + 4 modules
var SDContext = __webpack_require__(6406);
// EXTERNAL MODULE: ./components/Navbar/Navbar.module.scss
var Navbar_module = __webpack_require__(5927);
var Navbar_module_default = /*#__PURE__*/__webpack_require__.n(Navbar_module);
;// CONCATENATED MODULE: ./components/Navbar/Navbar.tsx








const NavMenu = (props)=>{
    const [showUserCard, setShowUserCard] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Navbar_module_default()).brand,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Brand/* default */.Z, {
                    onClick: props.redirectToHome
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                className: (Navbar_module_default()).auth,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Navbar_module_default()).avatarImage,
                        onClick: ()=>setShowUserCard(!showUserCard),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserImage, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Navbar_module_default()).userCardContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserCard_UserCard, {
                            showCard: showUserCard,
                            setShowCard: setShowUserCard
                        })
                    })
                ]
            })
        ]
    });
};
const Navbar = (props)=>{
    const router = (0,next_router.useRouter)();
    const { user , setAuthOption  } = (0,AuthContext/* useAuth */.aC)();
    const { selectedOption  } = (0,SDContext/* useDiffusion */.PW)();
    const redirectToHome = (0,react.useCallback)(async ()=>{
        router.push("/");
    }, [
        user,
        router
    ]);
    const redirectToProfile = (0,react.useCallback)(async ()=>{
        router.push("/profile");
    }, [
        router
    ]);
    const handleAuthActionClick = (0,react.useCallback)(async (authOption)=>{
        if (router.pathname !== "") {
            router.push("/");
            setAuthOption(authOption);
        }
        setAuthOption(authOption);
    }, [
        router,
        setAuthOption
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Navbar_module_default()).navbarContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavMenu, {
            user: user,
            selectedOption: selectedOption,
            redirectToHome: redirectToHome,
            redirectToProfile: redirectToProfile,
            handleAuthActionClick: handleAuthActionClick,
            isMobile: false,
            showBrand: props.showBrand
        })
    });
};
/* harmony default export */ var Navbar_Navbar = (Navbar);


/***/ }),

/***/ 7272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _ButtonPushable_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8772);
/* harmony import */ var _ButtonPushable_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ButtonPushable_module_scss__WEBPACK_IMPORTED_MODULE_1__);


const ButtonPushable = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_ButtonPushable_module_scss__WEBPACK_IMPORTED_MODULE_1___default())[props.variant || "default"],
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            role: "button",
            className: (_ButtonPushable_module_scss__WEBPACK_IMPORTED_MODULE_1___default().pushable),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_ButtonPushable_module_scss__WEBPACK_IMPORTED_MODULE_1___default().edge)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_ButtonPushable_module_scss__WEBPACK_IMPORTED_MODULE_1___default().front),
                    children: props.children
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonPushable);


/***/ }),

/***/ 2645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ CloseIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

const CloseIcon = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: props.width || "32",
        height: props.height || "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M18.1214 16.0005L27.5615 6.56147C28.1474 5.97549 28.1474 5.02543 27.5615 4.43949C26.9755 3.8535 26.0254 3.8535 25.4395 4.43949L16.0005 13.8795L6.56147 4.43949C5.97549 3.8535 5.02543 3.8535 4.43949 4.43949C3.85355 5.02547 3.8535 5.97553 4.43949 6.56147L13.8795 16.0005L4.43949 25.4395C3.8535 26.0255 3.8535 26.9755 4.43949 27.5615C5.02547 28.1474 5.97553 28.1474 6.56147 27.5615L16.0005 18.1214L25.4394 27.5615C26.0254 28.1474 26.9755 28.1474 27.5614 27.5615C28.1474 26.9755 28.1474 26.0254 27.5614 25.4395L18.1214 16.0005Z",
            fill: props.color || "white"
        })
    });


/***/ }),

/***/ 4400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ LogoutIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

const LogoutIcon = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "19",
        height: "21",
        viewBox: "0 0 19 21",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1 1.5V19.5M6 10.5H17M17 10.5L14 7.5M17 10.5L14 13.5",
            stroke: "black",
            "stroke-width": "2",
            "stroke-linecap": "round"
        })
    });


/***/ }),

/***/ 7235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ UserIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

const UserIcon = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "29",
        viewBox: "0 0 20 29",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "10",
                cy: "5.375",
                r: "3.5",
                stroke: "black",
                strokeWidth: "3"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6.92814 14.875C8.27529 12.5417 11.6432 12.5417 12.9903 14.875L17.8081 23.2197L9.95923 26.9631L2.11034 23.2197L6.92814 14.875Z",
                stroke: "black",
                strokeWidth: "3"
            })
        ]
    });


/***/ }),

/***/ 7463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useWindowDimensions; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./utils/constants.ts
const MOBILE_SCREEN_WIDTH = 768;

;// CONCATENATED MODULE: ./hooks/useWindowDimensions.ts


const useWindowDimensions = ()=>{
    const [windowDimensions, setWindowDimensions] = (0,react.useState)({
        width: undefined,
        height: undefined,
        isMobile: undefined
    });
    (0,react.useEffect)(()=>{
        function handleResize() {
            setWindowDimensions({
                width: window.innerWidth,
                height: window.innerHeight,
                isMobile: window.innerWidth < MOBILE_SCREEN_WIDTH
            });
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return windowDimensions;
};
/* harmony default export */ var hooks_useWindowDimensions = (useWindowDimensions);


/***/ }),

/***/ 2420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ uploadFileToServer; }
/* harmony export */ });
/* unused harmony export uploadMultipleFilesToServer */
/* harmony import */ var _httpClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6230);

const uploadFileToServer = async (file, destFolder)=>{
    try {
        const formData = new FormData();
        formData.append("file", file);
        const response = await _httpClient__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("files/upload", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            params: {
                folder: destFolder
            }
        });
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error
        };
    }
};
const uploadMultipleFilesToServer = async (files)=>{
    try {
        const formData = new FormData();
        files.forEach((file)=>{
            formData.append("files", file);
        });
        const response = await httpInstance.post("files/upload/multiple", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error
        };
    }
};


/***/ }),

/***/ 7361:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"authWrapper":"PrivateRoute_authWrapper__0P76s"};

/***/ }),

/***/ 9825:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"editProfileForm":"EditProfileForm_editProfileForm__SCqGL","avatarContainer":"EditProfileForm_avatarContainer__pobCP","avatarInput":"EditProfileForm_avatarInput__r5EEP","inputContent":"EditProfileForm_inputContent__vUpNy","button":"EditProfileForm_button__wJuVi"};

/***/ }),

/***/ 2145:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"Modal_modalContainer__trqEu","modalBody":"Modal_modalBody__nzWd_","modalHeader":"Modal_modalHeader__1FFG1","headerContent":"Modal_headerContent__ZbKju","closeIcon":"Modal_closeIcon__TiCNm"};

/***/ }),

/***/ 5927:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"signature":"Navbar_signature__y1l_w","caption-2":"Navbar_caption-2__oQeiw","caption-1":"Navbar_caption-1__1cPKz","base-2":"Navbar_base-2__XIMMc","base-1":"Navbar_base-1__ruTKo","body-3":"Navbar_body-3__lY1_d","body-2":"Navbar_body-2__g_2QD","body-1":"Navbar_body-1__njJiP","headline-6":"Navbar_headline-6__6qUHt","headline-5":"Navbar_headline-5__p3sNW","headline-4":"Navbar_headline-4__d_FLC","headline-3":"Navbar_headline-3__IOiw4","headline-2":"Navbar_headline-2__bjLx4","headline-1":"Navbar_headline-1___y4dF","brand":"Navbar_brand__OGPL_","button":"Navbar_button__0WFsP","bold64":"Navbar_bold64___A5mz","bold40":"Navbar_bold40__a1B4y","heading":"Navbar_heading__oQSJJ","bodyBold":"Navbar_bodyBold__5zGHd","bigBody":"Navbar_bigBody__EUndz","body":"Navbar_body__iTrCe","bold12":"Navbar_bold12__T77gc","boldSmall":"Navbar_boldSmall__Lwo0C","small":"Navbar_small__wzN2F","main":"Navbar_main__KxuSy","accent":"Navbar_accent__BDOg0","primary":"Navbar_primary__La5Qq","secondary":"Navbar_secondary__R4A6_","success":"Navbar_success__kdlIn","info":"Navbar_info__zT77c","danger":"Navbar_danger__p1IPh","white":"Navbar_white__KqaAq","grey":"Navbar_grey__WON6w","black":"Navbar_black__kswvL","mainColor":"Navbar_mainColor__YiWXR","upper":"Navbar_upper__GfPGG","capitalize":"Navbar_capitalize__INjaj","underline":"Navbar_underline__aiB_H","lineThrough":"Navbar_lineThrough__LmJ8A","ellipsis":"Navbar_ellipsis__7odjJ","pointer":"Navbar_pointer__Smy5L","shadow":"Navbar_shadow__r8LjK","center":"Navbar_center__tzhIH","left":"Navbar_left__zEB2_","right":"Navbar_right__NA7Q0","navbarContainer":"Navbar_navbarContainer__un8ww","links":"Navbar_links__xxOpa","activeLink":"Navbar_activeLink__X09aQ","auth":"Navbar_auth__b7l6n","avatarImage":"Navbar_avatarImage__gZ0mW","userCardContainer":"Navbar_userCardContainer__6iYLj","burgerMenuContent":"Navbar_burgerMenuContent__JU_3U","closeIcon":"Navbar_closeIcon__9oO6h"};

/***/ }),

/***/ 1529:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"userImage":"UserCard_userImage__pH6vj","userCardWrapper":"UserCard_userCardWrapper__HU4ld","userCardContainer":"UserCard_userCardContainer__uetIw","userHeader":"UserCard_userHeader__F9GEX","imageFilter":"UserCard_imageFilter__dCLUc","userInfo":"UserCard_userInfo__CEtY7","actionsContainer":"UserCard_actionsContainer__dAojk","profileItem":"UserCard_profileItem__tSlsE","logoutItem":"UserCard_logoutItem__p7MQI","icon":"UserCard_icon__Nt6mM"};

/***/ }),

/***/ 8790:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"userProfileContainer":"UserProfile_userProfileContainer__KnakE","userProfileNav":"UserProfile_userProfileNav__vuK0K","userProfileContent":"UserProfile_userProfileContent___kOk4","navItem":"UserProfile_navItem__MOfFl","active":"UserProfile_active__lvogL","mobileDeleteAccount":"UserProfile_mobileDeleteAccount__yjVoj"};

/***/ }),

/***/ 8772:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"default":"ButtonPushable_default__32q6X","pushable":"ButtonPushable_pushable__KRbrE","front":"ButtonPushable_front__UjsFJ","edge":"ButtonPushable_edge__GX21W","large":"ButtonPushable_large__QTBPt ButtonPushable_default__32q6X"};

/***/ })

}]);